import {Col, Row} from "antd";
import {Link} from "react-router-dom";

const NotFound = () => {
    return (
        <Row align={"middle"} justify={"center"}>
            <Col span={24}>
                <h1 style={{textAlign: "center"}}>Oupsss!</h1>
                <h3 style={{textAlign: "center"}}>We looked all over, but that page seems to have away from us.</h3>
                <p style={{textAlign: "center"}}><Link to="/">Show me the way</Link></p>
            </Col>
        </Row>
    )
}

export default NotFound;
